// Maximum length constants for WPS (Welding Procedure Specification) fields

// WeldingProcedure.jsx maxLength constants
export const maxLength_WPS = {
  // Process Grid Input fields
  WPSD_WP_MinimumPreheatTemp: 24,
  WPSD_WP_MaximumInterpassTemp:  24,
  WPSD_WP_FillerMetalSIze: 7,
  WPSD_WP_BatchNumber: 9,
  WPSD_WP_PositionOfFillet: 5,
  WPSD_WP_Amperes: 10,
  WPSD_WP_Amperes1:10,
  WPSD_WP_Pulsing_current: 24,
  WPSD_WP_Volts: 6,
  WPSD_WP_TravelSpeed: 7,
  WPSD_WP_MinimumBeadLength: 5,
  WPSD_WP_MaximumHeatInput: 5,
  
  // Gas flow fields
  WPSD_WP_ShieldingGasType: 18,
  WPSD_WP_ShieldingFlowRate: 18,
  WPSD_WP_BackingGasType: 18,
  WPSD_WP_BackingFlowRate: 18,
  WPSD_WP_TrailingGasType: 18,
  WPSD_WP_TrailingFlowRate: 18,
  
  // Other welding parameters
  WPSD_WP_StringOrWeave: 24,
  WPSD_WP_Orifice_GasCupSize: 24,
  WPSD_WP_CTWD: 24,
  WPSD_WP_Multiple_SingleLayer: 24,
  WPSD_WP_Multi_SingleElectrode: 24,
  WPSD_WP_ElectrodeSpacing_Late: 24,
  WPSD_WP_ElectrodeSpacing_Logit: 24,
  WPSD_WP_ElectrodeAngleDegree: 24,
  WPSD_WP_Weld_Bead_Overlap: 24,
  WPSD_WP_Max_Pass_Thickness: 24,
  WPSH_PWHeatTre_Temperature:12,
  
  // DataLogger fields
  WPSD_WP_MinimumPreheatTemp_DataLogger: 50,
  WPSD_WP_MaximumInterpassTemp_DataLogger: 50,
  WPSD_WP_Maximumtravelspeed_DataLogger: 50,

  //Tubesheet

  WPSD_WP_PostHeating: 28,
  WPSD_WP_MinimumPreheatTempTube: 10,
  WPSD_WP_MaximumInterpassTempTube: 10,
  WPSD_WP_TungstenType:28,
  WPSD_WP_WeldPosition:48,
  WPSD_WP_WeldProgression:28,
  WPSD_WP_NoofPasses:4,
  WPSD_WP_LayerNumber:10,
  WPSD_WP_Pulsing_current_others:25,
  WPSD_WP_HeatInput:10,
  WPSD_WP_CurrentPolarity:4,
  WPSD_WP_ArcVoltageControl:28,
  WPSD_WP_ShieldingGasType_Tube:25,
  WPSD_WP_BackingGasType_Tube:25,
  WPSD_WP_AuxiGasShieldSystem:38,
  WPSH_PWHeatTre_Time_Tube:12,
  WPSH_PWHeatTre_Cooling_Rate_Tube:20,
  WPSH_PWHeatTre_LoadingTemp:25,
  WPSH_PWHeatTre_UnloadingTemp:20,
  WPSH_PWHeatTre_PWHTNotes:85,
  WPSH_Tech_Expansion:28,
  WPSH_Tech_StringWave:28


};

// WeldingProcedureSpec.jsx maxLength constants
export const maxLength_WPSSpec = {
  // Post Weld Heat Treatment fields
  WPSH_PWHeatTre_Temperature: 12,
  WPSH_PWHeatTre_Time: 20,
  WPSH_PWHeatTre_Heating_Rate: 28,
  WPSH_PWHeatTre_Heating_Method: 20,
  WPSH_PWHeatTre_Cooling_Rate: 28,
  WPSH_PWHeatTre_Cooling_Method: 20,
  WPSH_PWHeatTre_Notes: 90,
  WPSH_PWHeatTre_Post_Heat_temp: 8,
  WPSH_PWHeatTre_Post_Heat_time: 8,
  WPSH_PWHeatTre_ISR_Temp: 15,
  WPSH_PWHeatTre_ISR_Time: 48,
  WPSH_PWHeatTre_Weld_Notes: 90,
  
  // Root spacing
  WPSH_PHT_Root_spacing: 50,
  
  // Other Variables - Groove
  WPSH_Tech_GroovePreparation: 80,
  WPSH_Tech_Change_Electrode_dia: 25,
  
  // Other Variables - Overlay
  WPSH_Tech_Weld_deposit_chemistry: 30,
  WPSH_Tech_Oscillation_Width: 20,
  WPSH_Tech_Oscillation_Freq: 20,
  WPSH_Tech_Filler_Metal_Del: 20,
  
  // Notes
  WPSH_Notes: 1500,
  
  // Prepared/Approved By
  WPSH_PreparedBy_Remark: 50,
  WPSH_ApprovedBy_Remark: 200

  
};

// Original maxlength_WPS from WPSGroove_entity.js (used in General.jsx)
export const maxlength_WPS = {
  WPSH_WPS_No: 20,
  WPSH_WPS_Revi_No: 3,
  WPS_QualifiedTo: 43,
  WPSH_SupportingPQR: 90,
  WPSH_RefDoc: 90,
  WPSH_Scope: 90,
  WPSH_JointDesc: 90,
  WPSH_BM_Type_Type: 38,
  WPSH_BM_Type_GNo: 4,
  WPSH_BM_Type_HT_Con: 13,
  WPSH_BM_WeldingTo_Type: 38,
  WPSH_BM_WeldingTo_GNo: 4,
  WPSH_BM_WeldingTo_HT_Con: 13,
  WPSH_BM_Backing_PNo: 4,
  WPSH_BM_Backing_GNo: 4,
  WPSH_BM_Backing_Material: 38,
  WPSH_BM_Retainer: 50,
  WPSH_BM_Notes: 60,
  WPSH_MinOvlFinThick:50
};




// Combined export for convenience
export const WPS_MAX_LENGTHS = {
  ...maxLength_WPS,
  ...maxLength_WPSSpec,
  ...maxlength_WPS
};